import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=477171ba&scoped=true"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"
import style0 from "./policies.vue?vue&type=style&index=0&id=477171ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477171ba",
  null
  
)

export default component.exports